exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img-thumbnail {\n    height: 100px !important;\n}\n\n", ""]);

// exports
